import * as Sentry from "@sentry/react";
import { useEffect } from "react";

export interface UseReviewPageSentryContextProps {
    detectorId?: string;
    imageQueryId?: string;
    labelingMode?: string;
    poolFilterMode?: string;
    isLabelerOnly?: boolean;
    isDisagreement?: boolean;
}

/**
 * Hook that sets Sentry tags and context for the Review Page.
 * Any error captured while on the Review Page will include detector,
 * image query, and labeling mode information for debugging.
 */
export function useReviewPageSentryContext({
    detectorId,
    imageQueryId,
    labelingMode,
    poolFilterMode,
    isLabelerOnly,
    isDisagreement,
}: UseReviewPageSentryContextProps): void {
    useEffect(() => {
        Sentry.setTag("page", "review");
        Sentry.setTag("is_labeler_only", String(isLabelerOnly ?? false));

        if (detectorId) {
            Sentry.setTag("detector_id", detectorId);
        }
        if (imageQueryId) {
            Sentry.setTag("image_query_id", imageQueryId);
        }
        if (labelingMode) {
            Sentry.setTag("labeling_mode", labelingMode);
        }
        if (poolFilterMode) {
            Sentry.setTag("pool_filter_mode", poolFilterMode);
        }

        Sentry.setContext("review_page", {
            detector_id: detectorId ?? null,
            image_query_id: imageQueryId ?? null,
            labeling_mode: labelingMode ?? null,
            pool_filter_mode: poolFilterMode ?? null,
            is_labeler_only: isLabelerOnly ?? false,
            is_disagreement: isDisagreement ?? false,
        });
    }, [
        detectorId,
        imageQueryId,
        labelingMode,
        poolFilterMode,
        isLabelerOnly,
        isDisagreement,
    ]);
}
